// User roles
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ORG_ADMIN: 'org_admin',
  ADMIN_UNIT_ADMIN: 'admin_unit_admin',
  MEMBER: 'member',
};

// Member statuses
export const MEMBER_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
};

// Case types
export const CASE_TYPES = [
  { value: 'welfare', label: 'Welfare' },
  { value: 'education', label: 'Education' },
  { value: 'medical', label: 'Medical' },
  { value: 'funeral', label: 'Funeral' },
];

// Case statuses
export const CASE_STATUS = {
  DRAFT: 'draft',
  PENDING_LOCAL: 'pending_local',
  PENDING_MONTHLY: 'pending_monthly',
  APPROVED: 'approved',
  OPEN: 'open',
  CLOSED: 'closed',
};

// Contribution status
export const CONTRIBUTION_STATUS = {
  UNPAID: 'unpaid',
  PAID: 'paid',
};

// Organization status
export const ORG_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

// Admin unit assignment scope
export const ADMIN_UNIT_SCOPE = {
  FULL: 'full',
  READ_ONLY: 'read_only',
};

// Toast notification types
export const TOAST_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
};

// API endpoints (base relative to API_URL)
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
  },
  ORGANIZATIONS: '/organizations',
  ADMIN_UNITS: '/admin-units',
  USERS: '/users',
  MEMBERS: '/members',
  CASES: '/cases',
  CONTRIBUTIONS: '/contributions',
  PAYMENTS: '/payments',
  REPORTS: '/reports',
  SETTINGS: '/settings',
  AUDIT: '/audit',
};

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
};